import { AxiosError } from "axios"
import { ErrorType } from "@/shared/types"

const statusMessages: Record<number, string> = {
    400: "Параметры фильтра заданы неверно",
    401: "Сессия истекла, войдите заново",
    403: "Нет доступа к запрошенному меню",
    404: "Запрошенное меню или заказ не найден",
    502: "Сервис заказов временно недоступен",
    503: "Сервис заказов временно недоступен",
    504: "Сервис заказов не ответил вовремя",
}

export const getRestaurantMenuAnalyticsErrorMessage = (error: unknown): string => {
    const knownError = error as AxiosError<ErrorType>
    const status = knownError.response?.status

    if (status && statusMessages[status]) {
        return statusMessages[status]
    }

    if (knownError.code === "ECONNABORTED") {
        return "Сервис не ответил вовремя. Повторите попытку"
    }

    if (!knownError.response) {
        return "Не удалось связаться с сервером. Проверьте соединение и повторите попытку"
    }

    return knownError.response.data?.message || "Произошла непредвиденная ошибка"
}
